import React, {lazy, Suspense} from "react";
import Loading from "../../containers/loading/Loading";

const LottiePlayer = lazy(() => import("lottie-react"));

export default function DisplayLottie({animationData}) {
  return (
    <Suspense fallback={<Loading />}>
      <LottiePlayer animationData={animationData} loop />
    </Suspense>
  );
}
